import { VariantType, useSnackbar } from "notistack";
import { useCallback } from "react";

export function useSnackbarMessage() {
  const { enqueueSnackbar } = useSnackbar();

  return useCallback(
    (message: string, variant: VariantType = "success") => {
      enqueueSnackbar(message, {
        autoHideDuration: 3000,
        variant,
        transitionDuration: { exit: 200, enter: 500 },
        anchorOrigin: { vertical: "top", horizontal: "center" },
      });
    },
    [enqueueSnackbar]
  );
}
